module.exports = __webpack_public_path__ + "static/media/actionable-insights.7c9a91a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/destination-prompt/actionable-insights.png
// module id = 713
// module chunks = 0